import { ComponentType } from 'react'

// This file will be populated as we migrate pages
// For now, we'll create placeholder components and add real ones as we migrate

/**
 * Route Registry
 * Maps database route paths to React components
 * This must include ALL possible routes that can come from the database
 */
// Import migrated pages
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import TwoFactor from '@/pages/TwoFactor'
import TwoFactorSetup from '@/pages/TwoFactor/Setup'
import Profile from '@/pages/Profile'
import UsersPage from '@/pages/UserManagement/Users'
import CreateUserPage from '@/pages/UserManagement/Users/Create'
import EditUserPage from '@/pages/UserManagement/Users/Edit'
import RolesPage from '@/pages/UserManagement/Roles'
import CreateRolePage from '@/pages/UserManagement/Roles/Create'
import EditRolePage from '@/pages/UserManagement/Roles/Edit'
import UserActivityPage from '@/pages/UserManagement/UserActivity'
import MobileDevicesPage from '@/pages/UserManagement/MobileDevices'
import GeneralSettingsPage from '@/pages/SystemSettings/General'
import EmailSettingsPage from '@/pages/SystemSettings/EmailSettings'
import SecuritySettingsPage from '@/pages/SystemSettings/Security'
import NavigationSettingsPage from '@/pages/SystemSettings/Navigation'
import CreateNavigationPage from '@/pages/SystemSettings/Navigation/Create'
import EditNavigationPage from '@/pages/SystemSettings/Navigation/Edit'
import ClientsPage from '@/pages/Clients'
import CreateClientPage from '@/pages/Clients/Create'
import EditClientPage from '@/pages/Clients/Edit'
import ClientPurchaseOrdersPage from '@/pages/ClientPurchaseOrders'
import CreateClientPurchaseOrderPage from '@/pages/ClientPurchaseOrders/Create'
import EditClientPurchaseOrderPage from '@/pages/ClientPurchaseOrders/Edit'
import FieldEngineersPage from '@/pages/FieldEngineers'
import CreateFieldEngineerPage from '@/pages/FieldEngineers/Create'
import EditFieldEngineerPage from '@/pages/FieldEngineers/Edit'
import DepartmentsPage from '@/pages/Departments'
import CreateDepartmentPage from '@/pages/Departments/Create'
import EditDepartmentPage from '@/pages/Departments/Edit'
import TeamsPage from '@/pages/Organization/Teams'
import CreateTeamPage from '@/pages/Organization/Teams/Create'
import EditTeamPage from '@/pages/Organization/Teams/Edit'
import AgentSkillsPage from '@/pages/Organization/AgentSkills'
import BusinessUnitsPage from '@/pages/Organization/BusinessUnits'
import CreateBusinessUnitPage from '@/pages/Organization/BusinessUnits/Create'
import EditBusinessUnitPage from '@/pages/Organization/BusinessUnits/Edit'
import AssignedDevicesPage from '@/pages/UserManagement/AssignedDevices'
import CreateAssignedDevicePage from '@/pages/UserManagement/AssignedDevices/Create'
import EditAssignedDevicePage from '@/pages/UserManagement/AssignedDevices/Edit'
import BackupRestorePage from '@/pages/SystemSettings/BackupRestore'
import CreateBackupPage from '@/pages/SystemSettings/BackupRestore/Create'
import BackupSchedulesPage from '@/pages/SystemSettings/BackupRestore/Schedules'
import CreateSchedulePage from '@/pages/SystemSettings/BackupRestore/Schedules/Create'
import EditSchedulePage from '@/pages/SystemSettings/BackupRestore/Schedules/Edit'
import EmailTemplatePage from '@/pages/SystemSettings/EmailTemplate'
import CreateEmailTemplatePage from '@/pages/SystemSettings/EmailTemplate/Create'
import EditEmailTemplatePage from '@/pages/SystemSettings/EmailTemplate/Edit'
import ApplicationsPage from '@/pages/SystemSettings/Applications'
import CreateApplicationPage from '@/pages/SystemSettings/Applications/Create'
import EditApplicationPage from '@/pages/SystemSettings/Applications/Edit'
import AppVersionsPage from '@/pages/SystemSettings/AppVersions'
import CreateAppVersionPage from '@/pages/SystemSettings/AppVersions/Create'
import EditAppVersionPage from '@/pages/SystemSettings/AppVersions/Edit'
import ContentPushPage from '@/pages/SystemSettings/ContentPush'
import DeviceHealthPage from '@/pages/SystemSettings/DeviceHealth'
import GraphMailboxSubscriptionPage from '@/pages/SystemSettings/GraphMailboxSubscription'
import StoresPage from '@/pages/StoreManagement/Stores'
import CreateStorePage from '@/pages/StoreManagement/Stores/Create'
import EditStorePage from '@/pages/StoreManagement/Stores/Edit'
import StoreDetailsPage from '@/pages/StoreManagement/Stores/Details'
import AssetConfigOverviewPage from '@/pages/AssetConfiguration/Overview'
import AssetConfigAssetsPage from '@/pages/AssetConfiguration/Assets'
import AssetConfigCategoriesPage from '@/pages/AssetConfiguration/Categories'
import AssetConfigCategoryCreatePage from '@/pages/AssetConfiguration/Categories/Create'
import AssetConfigCategoryEditPage from '@/pages/AssetConfiguration/Categories/Edit'
import AssetConfigFunctionsPage from '@/pages/AssetConfiguration/Functions'
import AssetConfigFunctionCreatePage from '@/pages/AssetConfiguration/Functions/Create'
import AssetConfigFunctionEditPage from '@/pages/AssetConfiguration/Functions/Edit'
import AssetConfigBrandsPage from '@/pages/AssetConfiguration/Brands'
import AssetConfigBrandCreatePage from '@/pages/AssetConfiguration/Brands/Create'
import AssetConfigBrandEditPage from '@/pages/AssetConfiguration/Brands/Edit'
import AssetConfigBrandModelsPage from '@/pages/AssetConfiguration/BrandModels'
import AssetConfigBrandModelCreatePage from '@/pages/AssetConfiguration/BrandModels/Create'
import AssetConfigBrandModelEditPage from '@/pages/AssetConfiguration/BrandModels/Edit'
import AssetConfigTagsPage from '@/pages/AssetConfiguration/Tags'
import AssetConfigTagCreatePage from '@/pages/AssetConfiguration/Tags/Create'
import AssetConfigTagEditPage from '@/pages/AssetConfiguration/Tags/Edit'
import AssetConfigSpecOptionListPage from '@/pages/AssetConfiguration/SpecOptionList'
import AssetConfigSpecOptionCreatePage from '@/pages/AssetConfiguration/SpecOptionList/Create'
import AssetConfigSpecOptionEditPage from '@/pages/AssetConfiguration/SpecOptionList/Edit'
import LegacyAssetCatalogRedirect from '@/pages/AssetConfiguration/LegacyRedirect'
import AssetConfigAssetCreatePage from '@/pages/AssetConfiguration/Assets/Create'
import AssetConfigAssetEditPage from '@/pages/AssetConfiguration/Assets/Edit'

const LegacyAssetCatalogOverview = () => <LegacyAssetCatalogRedirect segment="overview" />
const LegacyAssetCatalogAssets = () => <LegacyAssetCatalogRedirect segment="assets" />
const LegacyAssetCatalogAssetCreate = () => <LegacyAssetCatalogRedirect segment="assets/create" />
const LegacyAssetCatalogAssetEdit = () => <LegacyAssetCatalogRedirect segment="assets" />
const LegacyAssetCatalogCategories = () => <LegacyAssetCatalogRedirect segment="categories" />
const LegacyAssetCatalogFunctions = () => <LegacyAssetCatalogRedirect segment="functions" />
const LegacyAssetCatalogBrands = () => <LegacyAssetCatalogRedirect segment="brands" />
const LegacyAssetCatalogBrandModels = () => <LegacyAssetCatalogRedirect segment="brand-models" />
const LegacyAssetCatalogTags = () => <LegacyAssetCatalogRedirect segment="tags" />
const LegacyAssetCatalogSpecs = () => <LegacyAssetCatalogRedirect segment="spec/ram" />
const LegacyAssetCatalogEquipment = () => <LegacyAssetCatalogRedirect segment="categories" />
const LegacyAssetCatalogBrandsModels = () => <LegacyAssetCatalogRedirect segment="brands" />
import AreaClustersPage from '@/pages/StoreManagement/AreaClusters'
import CreateAreaClusterPage from '@/pages/StoreManagement/AreaClusters/Create'
import EditAreaClusterPage from '@/pages/StoreManagement/AreaClusters/Edit'
import GeographicRegionsPage from '@/pages/StoreManagement/GeographicRegions'
import CreateGeographicRegionPage from '@/pages/StoreManagement/GeographicRegions/Create'
import EditGeographicRegionPage from '@/pages/StoreManagement/GeographicRegions/Edit'
import ProvincesPage from '@/pages/StoreManagement/Provinces'
import CreateProvincePage from '@/pages/StoreManagement/Provinces/Create'
import EditProvincePage from '@/pages/StoreManagement/Provinces/Edit'
import TownsPage from '@/pages/StoreManagement/Towns'
import CreateTownPage from '@/pages/StoreManagement/Towns/Create'
import EditTownPage from '@/pages/StoreManagement/Towns/Edit'
import UserManualPage from '@/pages/Help/UserManual'
import FaqPage from '@/pages/Help/Faq'

export const routeRegistry: Record<string, ComponentType<any>> = {
  // Public routes
  '/login': Login,
  '/forgot-password': ForgotPassword,
  '/reset-password': ResetPassword,
  '/two-factor': TwoFactor,
  '/two-factor/setup': TwoFactorSetup,

  // Dashboard (shared)
  '/dashboard': Dashboard,

  // Profile (shared)
  '/profile': Profile,

  // Help (always available to authenticated users)
  '/user-manual': UserManualPage,
  '/faq': FaqPage,

  // ============================================
  // AUTH APPLICATION (auth.actionlabs.com.ph)
  // ============================================

  // Organization Section
  '/organization/departments': DepartmentsPage,
  '/organization/departments/create': CreateDepartmentPage,
  '/organization/departments/:id': EditDepartmentPage,
  '/organization/teams': TeamsPage,
  '/organization/teams/create': CreateTeamPage,
  '/organization/teams/:id': EditTeamPage,
  '/organization/clients': ClientsPage,
  '/organization/clients/create': CreateClientPage,
  '/organization/clients/:id': EditClientPage,
  '/organization/client-purchase-orders': ClientPurchaseOrdersPage,
  '/organization/client-purchase-orders/create': CreateClientPurchaseOrderPage,
  '/organization/client-purchase-orders/:id': EditClientPurchaseOrderPage,
  '/organization/field-engineers': FieldEngineersPage,
  '/organization/field-engineers/create': CreateFieldEngineerPage,
  '/organization/field-engineers/:id': EditFieldEngineerPage,
  '/organization/agent-skills': AgentSkillsPage,
  '/organization/business-units': BusinessUnitsPage,
  '/organization/business-units/create': CreateBusinessUnitPage,
  '/organization/business-units/:id': EditBusinessUnitPage,
  '/organization/stores': StoresPage,
  '/organization/stores/create': CreateStorePage,
  '/organization/stores/:id': EditStorePage,
  '/organization/stores/:id/details': StoreDetailsPage,
  '/organization/area-clusters': AreaClustersPage,
  '/organization/area-clusters/create': CreateAreaClusterPage,
  '/organization/area-clusters/:id': EditAreaClusterPage,
  '/organization/geographic-regions': GeographicRegionsPage,
  '/organization/geographic-regions/create': CreateGeographicRegionPage,
  '/organization/geographic-regions/:id': EditGeographicRegionPage,
  '/organization/provinces': ProvincesPage,
  '/organization/provinces/create': CreateProvincePage,
  '/organization/provinces/:id': EditProvincePage,
  '/organization/towns': TownsPage,
  '/organization/towns/create': CreateTownPage,
  '/organization/towns/:id': EditTownPage,

  // Access Control Section
  '/user-management/users': UsersPage,
  '/user-management/users/create': CreateUserPage,
  '/user-management/users/:id': EditUserPage,
  '/user-management/roles': RolesPage,
  '/user-management/roles/create': CreateRolePage,
  '/user-management/roles/:id': EditRolePage,
  '/user-management/user-activity': UserActivityPage,
  '/user-management/user-activity/:id': UserActivityPage,
  '/user-management/assigned-devices': AssignedDevicesPage,
  '/user-management/assigned-devices/create': CreateAssignedDevicePage,
  '/user-management/assigned-devices/:id': EditAssignedDevicePage,
  '/user-management/mobile-devices' : MobileDevicesPage,

  // System Settings Section
  '/system-settings/general': GeneralSettingsPage,
  '/system-settings/settings': GeneralSettingsPage, // Alias for backward compatibility
  '/system-settings/security': SecuritySettingsPage,
  '/system-settings/email-settings': EmailSettingsPage,
  '/system-settings/email-template': EmailTemplatePage,
  '/system-settings/email-template/create': CreateEmailTemplatePage,
  '/system-settings/email-template/:id': EditEmailTemplatePage,
  '/system-settings/applications': ApplicationsPage,
  '/system-settings/applications/create': CreateApplicationPage,
  '/system-settings/applications/:id': EditApplicationPage,
  '/system-settings/app-versions': AppVersionsPage,
  '/system-settings/app-versions/create': CreateAppVersionPage,
  '/system-settings/app-versions/:id': EditAppVersionPage,
  '/system-settings/content-push': ContentPushPage,
  '/system-settings/device-health': DeviceHealthPage,
  '/system-settings/navigation': NavigationSettingsPage,
  '/system-settings/navigation/create': CreateNavigationPage,
  '/system-settings/navigation/:id': EditNavigationPage,
  '/system-settings/backup-restore': BackupRestorePage,
  '/system-settings/backup-restore/create': CreateBackupPage,
  '/system-settings/backup-restore/schedules': BackupSchedulesPage,
  '/system-settings/backup-restore/schedules/create': CreateSchedulePage,
  '/system-settings/backup-restore/schedules/:id': EditSchedulePage,
  '/system-settings/mailbox-graph-subscription': GraphMailboxSubscriptionPage,

  // Asset Catalog — client workspace (Organization → Clients → Manage Asset Catalog)
  '/organization/clients/:clientId/asset-catalog': AssetConfigOverviewPage,
  '/organization/clients/:clientId/asset-catalog/overview': AssetConfigOverviewPage,
  '/organization/clients/:clientId/asset-catalog/assets': AssetConfigAssetsPage,
  '/organization/clients/:clientId/asset-catalog/assets/create': AssetConfigAssetCreatePage,
  '/organization/clients/:clientId/asset-catalog/assets/:id': AssetConfigAssetEditPage,
  '/organization/clients/:clientId/asset-catalog/categories': AssetConfigCategoriesPage,
  '/organization/clients/:clientId/asset-catalog/categories/create': AssetConfigCategoryCreatePage,
  '/organization/clients/:clientId/asset-catalog/categories/:id': AssetConfigCategoryEditPage,
  '/organization/clients/:clientId/asset-catalog/functions': AssetConfigFunctionsPage,
  '/organization/clients/:clientId/asset-catalog/functions/create': AssetConfigFunctionCreatePage,
  '/organization/clients/:clientId/asset-catalog/functions/:id': AssetConfigFunctionEditPage,
  '/organization/clients/:clientId/asset-catalog/brands': AssetConfigBrandsPage,
  '/organization/clients/:clientId/asset-catalog/brands/create': AssetConfigBrandCreatePage,
  '/organization/clients/:clientId/asset-catalog/brands/:id': AssetConfigBrandEditPage,
  '/organization/clients/:clientId/asset-catalog/brand-models': AssetConfigBrandModelsPage,
  '/organization/clients/:clientId/asset-catalog/brand-models/create': AssetConfigBrandModelCreatePage,
  '/organization/clients/:clientId/asset-catalog/brand-models/:id': AssetConfigBrandModelEditPage,
  '/organization/clients/:clientId/asset-catalog/tags': AssetConfigTagsPage,
  '/organization/clients/:clientId/asset-catalog/tags/create': AssetConfigTagCreatePage,
  '/organization/clients/:clientId/asset-catalog/tags/:id': AssetConfigTagEditPage,
  '/organization/clients/:clientId/asset-catalog/spec/:specType': AssetConfigSpecOptionListPage,
  '/organization/clients/:clientId/asset-catalog/spec/:specType/create': AssetConfigSpecOptionCreatePage,
  '/organization/clients/:clientId/asset-catalog/spec/:specType/:id': AssetConfigSpecOptionEditPage,

  // Legacy /asset-configuration/* → client workspace or Clients list
  '/asset-configuration': LegacyAssetCatalogOverview,
  '/asset-configuration/overview': LegacyAssetCatalogOverview,
  '/asset-configuration/assets': LegacyAssetCatalogAssets,
  '/asset-configuration/assets/create': LegacyAssetCatalogAssetCreate,
  '/asset-configuration/assets/:id': LegacyAssetCatalogAssetEdit,
  '/asset-configuration/equipment': LegacyAssetCatalogEquipment,
  '/asset-configuration/brands-models': LegacyAssetCatalogBrandsModels,
  '/asset-configuration/specs': LegacyAssetCatalogSpecs,
  '/asset-configuration/categories': LegacyAssetCatalogCategories,
  '/asset-configuration/functions': LegacyAssetCatalogFunctions,
  '/asset-configuration/brands': LegacyAssetCatalogBrands,
  '/asset-configuration/brand-models': LegacyAssetCatalogBrandModels,
  '/asset-configuration/tags': LegacyAssetCatalogTags,
  '/asset-configuration/spec/:specType': LegacyAssetCatalogSpecs,

  // Legacy store paths (redirect targets / bookmarks)
  '/store-management/stores': StoresPage,
  '/store-management/stores/create': CreateStorePage,
  '/store-management/stores/:id': EditStorePage,
  '/store-management/stores/:id/details': StoreDetailsPage,

  // ============================================
  // SIMA APPLICATION (workhub-sima.actionlabs.com.ph)
  // ============================================
  // TODO: Add routes when pages are created for SIMA application:
  // Master Data: '/master-data/media-library', '/master-data/categories', '/master-data/brands', etc.
  // Store Management business units: '/store-management/business-unit'
  // Inventory Management: '/inventory-management/assets', '/inventory-management/asset-assignments'
  // Audit Management: '/audit-management/audit-requests', '/audit-management/reports'
  // Communication: '/communication/announcements'

  // ============================================
  // ADMIN-SUPPORT APPLICATION (admin-support.actionlabs.com.ph)
  // ============================================
  // TODO: Add routes when pages are created:
  // '/ticketing/admin/tickets': AdminTicketsPage,
  // '/ticketing/admin/service-tasks': ServiceTasksPage,

  // ============================================
  // SUPPORT APPLICATION (support.actionlabs.com.ph)
  // ============================================
  // TODO: Add routes when pages are created:
  // '/ticketing/client/tickets': MyRequestsPage,
  // '/ticketing/client/tickets/create': SubmitRequestPage,
  // '/ticketing/client/tickets/status': RequestStatusPage,
  // '/ticketing/client/tickets/history': RequestHistoryPage,
  // '/reports': ReportsPage,
  // '/reports/audit-reports': AuditReportsPage,
  // '/help-center': HelpCenterPage,
}

/**
 * Get component for a route path
 * Handles dynamic segments (e.g., :id, :userId)
 */
export function getRouteComponent(path: string): ComponentType<any> | null {
  // Direct match
  if (routeRegistry[path]) {
    return routeRegistry[path]
  }

  // Try to match dynamic routes
  // e.g., "/categories/123" matches "/categories/:id"
  const dynamicPatterns = Object.keys(routeRegistry).filter(key => key.includes(':'))

  for (const pattern of dynamicPatterns) {
    const regex = new RegExp('^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$')
    if (regex.test(path)) {
      return routeRegistry[pattern]
    }
  }

  return null
}

/**
 * Get the registry key (pattern) that matches a route path.
 * For direct matches, returns the path itself; for dynamic routes, returns the pattern key.
 */
export function getRoutePatternKey(path: string): string | null {
  if (routeRegistry[path]) {
    return path
  }

  const dynamicPatterns = Object.keys(routeRegistry).filter((key) => key.includes(':'))

  for (const pattern of dynamicPatterns) {
    const regex = new RegExp('^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$')
    if (regex.test(path)) {
      return pattern
    }
  }

  return null
}

